import React, { useEffect, useState } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import Brands1 from "../brands/Brands1";
import Clientspeak from "../testimonials/Clientspeak";
import { FaArrowRight, FaPlay } from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";
import { Link } from "react-router-dom";
import VideoModal from "../modal/VideoModal";


const EcommerceRetail = () => {
    const [openVideoId, setOpenVideoId] = useState(null);



  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      {/* Breadcrumbs */}
      <BreadcrumbsHeader
        title="eCommerce & Retail"
        backgroundImage="/images/breadcrumbs/ecommerce.jpeg"
      />

      {/* Intro Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <div className="b-mod-heading text-center">
                <p className="first-heading font-secondary wow fadeInDown">
                  Robust &amp; Reliable Tech and Digital Marketing Solutions for
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn">
                  <strong>eCommerce &amp; Retail Industry</strong>
                </h2>
                <p className="second-heading font-additional">
                  Technology &amp; digital marketing is the very foundation of
                  the eCommerce &amp; Retail industry. Be it ever product
                  selling, automation, eCommerce or retail business management
                  or targeting &amp; managing the employees, everything is
                  possible via technology &amp; digital solutions.
                  <br />
                  Serving as a technology &amp; digital partner of eCommerce
                  companies and retail companies, we have the years of rich
                  experience in delivering edge cutting software and digital
                  solutions &amp; services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Offerings Section */}
      <section className="section-about">
        <div className="container-bg-additional relative clearfix">
          <div className="b-services-bg-filter customBgColor"></div>
          <div className="b-featured-services">
            <div className="container">
              <div className="row">
                {/* Left Content */}
                <div className="col-xs-12 col-sm-7 col-md-6 col-lg-7">
                  <div className="featured-services-left wow slideInLeft">
                    <div className="b-f-s-info offer">
                      <h3 className="f-s-title">
                        Our Offerings For <br />
                        eCommerce &amp; Retail
                      </h3>
                      <p>
                        We have wide range of web, cloud and digital marketing
                        solutions &amp; services for eCommerce companies and
                        retail entities.
                      </p>
                      <Link
                                              to="/contact"
                                              className="btn btn-default-arrow btn-sm"
                                            >
                                              <FaArrowRight /> get in touch
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Right Content */}
                <div className="col-xs-11 col-sm-5 col-md-5 col-lg-5">
                  <div className="bank featured-services-right wow fadeIn">
                    <div className="b-work-steps">
                      {[
                        {
                          title: "Application Services",
                          text: "Designing cloud based web applications for eCommerce & Retail companies.",
                        },
                        {
                          title: "Mobility Services",
                          text: "Enabling to grow smart with official mobile app for eCommerce & Retail businesses.",
                        },
                        {
                          title: "Cloud Infrastructure Services",
                          text: "Providing & managing end-to-end cloud infra for the cloud & mobiles apps.",
                        },
                        {
                          title: "Business Process Services",
                          text: "Managing overall customer relationship & support process.",
                        },
                        {
                          title: "Digitalisation & Technology Automation",
                          text: "Overall digitisation of the eCommerce or retail business and enhancement via tech automation.",
                        },
                      ].map((item, index) => (
                        <div className="b-services-item" key={index}>
                          <div className="services-icon">
                            <div className="circle-0">
                              <div className="circle-1">
                                <div className="circle-2"></div>
                              </div>
                            </div>
                          </div>
                          <div className="services-text">
                            <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                              <span className="customColor">{index + 1}.</span>{" "}
                              {item.title}
                            </h6>
                            <p>{item.text}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* End Right */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose ISOLS */}
      <section className="section-about">
        <div className="container">
          <div className="b-home-video-block">
            <div className="container-fluid">
              {/* Left Side (Video) */}
              <div className="col-xs-12 col-sm-5 col-md-6 col-lg-6 left-side wow slideInLeft">
                <div className="b-video-holder">
                    <Link
                    className="video-image playVideo"
                    to="#"
                    data-toggle="lightbox"
                      onClick={() => setOpenVideoId('eq3jsESwuzQ')}
                    data-title="Why Choose ISOLS Group"
                  >
                    <FaPlay className="demo-icon play-icon" />
                    <span className="video-title">play the video</span>
                  </Link>
                </div>
              </div>

              {/* Right Side (Content) */}
              <div className="col-xs-12 col-sm-7 col-md-6 col-lg-6 right-side wow slideInRight">
                <div className="content">
                  <div className="b-mod-heading">
                    <p className="first-heading customPseudoElBg font-secondary">
                      Why Choose
                    </p>
                    <h2 className="heading-line line-right">
                      <strong>ISOLS?</strong>
                    </h2>
                    <div className="b-text">
                      <p>
                        Designing &amp; implementing industry specific
                        technology and digital solution for industry automation
                        &amp; enhancement is our forte and we do it very
                        passionately. The solutions that we design are strongly
                        backed by strong thorough research, study of industry
                        challenges and pilot implementation of the solution.
                      </p>
                    </div>
                    
                     <Link
                      to="/about-isolsgroup"
                      className="btn btn-default-arrow"
                    >
                      <FaArrowRight /> know more about ISOLS Group
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <Clientspeak />

      {/* Brands */}
      <Brands1 />

      
       <VideoModal
        open={!!openVideoId}
        onClose={() => setOpenVideoId(null)}
        videoId={openVideoId}
      />

    </div>
  );
};

export default EcommerceRetail;